// extracted by mini-css-extract-plugin
export default {"completedTaskPageBackBtn":"ResponseDetail_completedTaskPageBackBtn__SojEl","formDate":"ResponseDetail_formDate__ip-C6"};